import DialogContentText from "@material-ui/core/DialogContentText";
import ActionDialog from "@saleor/components/ActionDialog";
import useDownloadReport from "@saleor/hooks/useDownloadReport";
import useNavigator from "@saleor/hooks/useNavigator";
import createDialogActionHandlers from "@saleor/utils/handlers/dialogActionHandlers";
import createFilterHandlers from "@saleor/utils/handlers/filterHandlers";
import Moment from "moment";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { reportsDownload } from "../../../utils/utils";
import MallOrdersListPage from "../../components/MallOrdersListPage";
import { useMallOrdersQuery } from "../../queries";
import {
  mallOrdersListUrl,
  MallOrdersListUrlDialog,
  MallOrdersUrlQueryParams
} from "../../url";
import { filterReportData } from "../../utils";
import {
  areFiltersApplied,
  getFilterOpts,
  getFilterQueryParam,
  getFilterTabs,
  getFilterVariables
} from "./filters";

function MallOrdersList({ params }) {
  const navigate = useNavigator();
  const currencySymbol = "PHP";
  const intl = useIntl();

  const tabs = getFilterTabs();

  const filterOpts = getFilterOpts(params);

  const [openModal, closeModal] = createDialogActionHandlers<
    MallOrdersListUrlDialog,
    MallOrdersUrlQueryParams
  >(navigate, mallOrdersListUrl, params);

  const queryVariables = React.useMemo(
    () => ({
      filter: getFilterVariables(params)
    }),

    [params]
  );

  const currentTab =
    params.activeTab === undefined
      ? areFiltersApplied(params)
        ? tabs.length + 1
        : 0
      : parseInt(params.activeTab, 0);

  const [
    changeFilters,
    resetFilters,
    handleSearchChange
  ] = createFilterHandlers({
    createUrl: mallOrdersListUrl,
    getFilterQueryParam,
    navigate,
    params
  });

  const { data: mallOrders } = useMallOrdersQuery({
    displayLoader: true,
    skip: false,
    variables: queryVariables
  });

  const handleDownload = () => {
    const dateNow = Moment(new Date()).format("YYYYMMDDHHmmss");
    const fileName = `${reportsDownload.mallOrdersBi.filename}_${dateNow}.xlsx`;
    const sheetName = "MALL ORDERS";
    const mallOrderFields = reportsDownload.mallOrdersBi.fields;

    const val = filterReportData(
      mallOrders?.mallOrderCount?.data,
      reportsDownload.mallOrdersBi.fields
    );

    useDownloadReport(val, mallOrderFields, sheetName, fileName);
    closeModal();
  };

  return (
    <>
      <MallOrdersListPage
        mallOrders={mallOrders}
        currencySymbol={currencySymbol}
        currentTab={currentTab}
        initialSearch={params.query || ""}
        filterOpts={filterOpts}
        onAll={resetFilters}
        onFilterChange={changeFilters}
        onSearchChange={handleSearchChange}
        onTabChange={function(): void {
          throw new Error("Function not implemented.");
        }}
        onTabDelete={function(): void {
          throw new Error("Function not implemented.");
        }}
        onTabSave={function(): void {
          throw new Error("Function not implemented.");
        }}
        tabs={tabs}
        handleDownload={() => openModal("download")}
      />
      <ActionDialog
        open={params.action === "download"}
        onClose={closeModal}
        confirmButtonState="default"
        onConfirm={handleDownload}
        variant="default"
        title={intl.formatMessage({
          defaultMessage: "Download Mall Orders",
          description: "dialog title"
        })}
      >
        <DialogContentText>
          <FormattedMessage
            defaultMessage="You are about to download a mall orders report with {total} rows. Do you want to continue?"
            values={{
              total: <strong>{mallOrders?.mallOrderCount.data.length}</strong>
            }}
          />
        </DialogContentText>
      </ActionDialog>
    </>
  );
}

export default MallOrdersList;
